<template>
  <div>
    <gmap-map :center="center" :zoom="13" style="width:100%;  height: 100vh;">
      <gmap-marker
        v-for="(marker, index) in allMarker"
        :key="index"
        :position="marker"
      >
        <!-- :icon="{ url: marker_icon }" -->
      </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: 'ViewMapCreateOrUpdate',
  props: ['value'],
  data() {
    return {
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      // marker_icon: require('@/assets/marker.png')
    }
  },
  created() {
    if (this.value) {
      var locat = this.value.customer_list
      this.center = locat[0] ? locat[0].gis_location[0] : { lng: 105.57359185298843, lat: 12.291513194851614 }
    }
  },
  computed: {
    allMarker() {
      if (this.value) {
        if(this.value.customer_list.length)
        {
          return this.value.customer_list.map(el => el.gis_location ? el.gis_location[0] : undefined )
        }

        return []
      }
      return []
    }
  },
  watch: {
    'value.customer_list': {
      handler(){
        if (this.value) {
          var locat = this.value.customer_list
          if(locat.length){
            this.center = locat[0].gis_location[0]
          }
        }
      },
      deep: true
    }
  }
}
</script>
